function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#020202"
}, React.createElement("path", {
  d: "M14.944 11.455c-.947 0-1.836.369-2.506 1.038a3.546 3.546 0 0 0 0 5.011 3.521 3.521 0 0 0 2.506 1.038c.947 0 1.836-.369 2.506-1.038a3.546 3.546 0 0 0 0-5.011 3.525 3.525 0 0 0-2.506-1.038z"
}), React.createElement("path", {
  d: "M16 0C7.163 0 0 7.163 0 16s7.163 16 16 16 16-7.163 16-16S24.837 0 16 0zm6.495 22.55a.697.697 0 0 1-.99 0l-3.561-3.561c-.017-.017-.024-.04-.039-.059a4.923 4.923 0 0 1-2.961 1.012 4.942 4.942 0 1 1 0-9.887c1.265 0 2.53.483 3.496 1.448 1.764 1.764 1.897 4.52.436 6.457.019.015.041.022.059.039l3.561 3.561a.7.7 0 0 1-.001.99z"
}));

var SvgSearchFilled = function SvgSearchFilled(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 16 : _ref$size,
      props = _objectWithoutProperties(_ref, ["size"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    height: size,
    width: size
  }, props), _ref2);
};

export default SvgSearchFilled;